import { render, staticRenderFns } from "./InterestExample.vue?vue&type=template&id=4631a0a6&"
import script from "./InterestExample.vue?vue&type=script&lang=js&"
export * from "./InterestExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports